import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import '../styles/sponsor.scss';
export default class Sponsor extends React.Component {
    render() {
        return (_jsx("div", { className: "sponsor", children: _jsxs("div", { className: "sponsor__container", children: [this.props.content.logo ? (_jsx("img", { className: "sponsor__thumb", src: this.props.content.logo.thumb, alt: "Sponsor image" })) : null, _jsx("div", { className: "sponsor__title", children: this.props.content.title }), _jsx("div", { className: "sponsor__subtitle", children: this.props.content.subtitle }), _jsx("div", { className: "sponsor__clear" }), this._renderDetails()] }) }));
    }
    _renderDetails() {
        if (this.props.content.details && this.props.content.details.length > 0) {
            return (_jsx("div", { className: "offer__redemption", children: _jsx("div", { children: this.props.content.details.map(this._renderDetail.bind(this)) }) }));
        }
        else {
            return null;
        }
    }
    _renderDetail(model, index) {
        return (_jsxs("div", { children: [_jsx("div", { children: model.title }), _jsxs("div", { children: [model.image ? _jsx("img", { className: "sponsor__thumb", src: model.image.thumb, alt: "Sponsor image" }) : _jsx("div", {}), _jsx("div", { className: "sponsor__subtitle", children: model.body }), _jsx("div", { className: "sponsor__clear" })] })] }, index));
    }
}
